var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessNotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 9.99999C1.04175 5.07148 5.07157 1.04166 10.0001 1.04166C14.9286 1.04166 18.9584 5.07148 18.9584 9.99999C18.9584 14.9285 14.9286 18.9583 10.0001 18.9583C5.07157 18.9583 1.04175 14.9285 1.04175 9.99999ZM10.0001 2.29166C5.76193 2.29166 2.29175 5.76183 2.29175 9.99999C2.29175 14.2381 5.76193 17.7083 10.0001 17.7083C14.2382 17.7083 17.7084 14.2381 17.7084 9.99999C17.7084 5.76183 14.2382 2.29166 10.0001 2.29166Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9841 7.20011C14.2279 7.4444 14.2276 7.84013 13.9833 8.08399L9.2583 12.8007C9.01416 13.0444 8.61873 13.0442 8.37481 12.8003L6.01647 10.4419C5.7724 10.1979 5.7724 9.80213 6.01647 9.55805C6.26055 9.31397 6.65628 9.31397 6.90036 9.55805L8.81714 11.4748L13.1002 7.19933C13.3445 6.95546 13.7402 6.95581 13.9841 7.20011Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNotify);
export default __webpack_public_path__ + "static/media/successNotify.0101894d0a007d8516300e372622620e.svg";
export { ForwardRef as ReactComponent };